import { render, staticRenderFns } from "./UserSkills.vue?vue&type=template&id=4cfb0f86"
import script from "./UserSkills.js?vue&type=script&lang=js&external"
export * from "./UserSkills.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports